// import A11yDialog from "a11y-dialog";
import * as utils from "./utils";
export const modalDialog = () => {
    const dialogContainer = document.querySelector("#testimonialDialog");
    if (utils.ifSelectorExist(dialogContainer)) {
        const videoReviewsDialog = new A11yDialog(dialogContainer);

        let fireTestimonialModalSelector = utils.getElements(
            ".fireTestimonialModal"
        );
        if (utils.ifSelectorExist(fireTestimonialModalSelector)) {
            Array.from(fireTestimonialModalSelector).forEach(item => {
                item.addEventListener("click", () => {
                    console.log("clicked by modal button");
                    let testimonialVideoIdSelector = utils.getElement(
                        "#testimonialVideoIdSelector"
                    );
                    if (utils.ifSelectorExist(testimonialVideoIdSelector)) {
                        let itemYtUrl = item.getAttribute("data-yt-url");
                        testimonialVideoIdSelector.src = itemYtUrl;
                    }
                });
            });
        }

        videoReviewsDialog.on("hide", function (dialogEl, event) {
            dialogEl
                .querySelector("iframe")
                .contentWindow.postMessage(
                    '{"event":"command","func":"pauseVideo","args":""}',
                    "*"
                );
        });

        videoReviewsDialog.on("show", function (dialogEl, event) {
            dialogEl.querySelector("iframe").onload = () => {
                dialogEl
                    .querySelector("iframe")
                    .contentWindow.postMessage(
                        '{"event":"command","func":"playVideo","args":""}',
                        "*"
                    );
            };
        });
    }
};
